'use es6';

import I18n from 'I18n';
/**
 * @param {String} type
 * @return {Boolean}
 */

export function isCellType(type) {
  return type === 'cell' || type === 'widget_container' || type === 'virtual_cell';
}
/**
 * @param {String} type
 * @return {Boolean}
 */

export function isVirtualCellType(type) {
  return type === 'virtual_cell';
}
/**
 * @param {String} type
 * @return {Boolean}
 */

export function isFlexColumnType(type) {
  return type === 'widget_container';
}
/**
 * @param {String} type
 * @return {Boolean}
 */

export function isSectionDelimiterType(type) {
  return type === 'section_delimiter';
}
/**
 * @param {String} type
 * @return {Boolean}
 */

export function isGlobalType(type) {
  return type === 'global_group' || type === 'global_widget';
}
/**
 * @param {String} type
 * @return {Boolean}
 */

export function isGlobalGroupType(type) {
  return type === 'global_group';
}
/**
 * @param {String} type
 * @return {String}
 */

export function getI18nWidgetTypeOptionKey(type) {
  if (isFlexColumnType(type)) return 'flexCol';
  if (isCellType(type)) return 'group';
  if (isGlobalGroupType(type)) return 'globalGroup';
  if (isGlobalType(type)) return 'globalModule';
  return 'widget';
}
export const getI18nWidgetTypeLabel = type => I18n.text(`designdata.widgetCatalog.widgets.${type}.title`);
export function getWidgetLabel(widget) {
  if (!widget) {
    return null;
  }

  if (widget.type === 'custom_widget') {
    if (widget.displayName) {
      return widget.displayName;
    }

    return widget.name;
  }

  return widget.label;
}
export function isLegacyImageType(type) {
  return type === 'linked_image' || type === 'logo';
}
export function isLogoType(widget = {}) {
  return widget.type === 'logo' || widget.params && widget.params.path === '@hubspot/logo';
}
export function isImageType(widget = {}) {
  return isLegacyImageType(widget.type) || widget.params && widget.params.path === '@hubspot/linked_image' || isLogoType(widget);
}
export function isLegacyImageSliderType(type) {
  return type === 'image_slider' || type === 'gallery';
}
export function isLegacyFormType(type) {
  return type === 'form';
}